export function getTicks(multiplier: number) {
  const result = [0];

  result.push(Number((multiplier / 2).toFixed(2)));
  result.push(Number(multiplier.toFixed(2)));

  return result;
}
